{
  "Open support, new reply": "サポートを開く（新しい返信があります）",
  "Open support": "サポートを開く",
  "Attachment": "添付ファイル",
  "Fin · previous AI assistant": "Fin · 以前のAIアシスタント",
  "EventLive support team": "EventLiveサポートチーム",
  "{name} · EventLive support": "{name} · EventLiveサポート",
  "EventLive AI assistant": "EventLiveのAIアシスタント",
  "Could not restore your previous conversation. You can retry by reopening the app.": "以前の会話を復元できませんでした。アプリを開き直すと、もう一度試せます。",
  "Please choose a smaller image.": "もっと小さい画像を選んでください。",
  "Please choose a JPEG or PNG image.": "JPEGまたはPNG画像を選んでください。",
  "Open {name}": "{name}を開く",
  "We’re here to help": "お気軽にご相談ください",
  "Team review requested · AI can still help": "チームに確認を依頼しました · AIも引き続きお手伝いできます",
  "Collapse chat": "チャットを折りたたむ",
  "Expand chat": "チャットを展開",
  "Close support": "サポートを閉じる",
  "Current conversation": "現在の会話",
  "Hi! Ask me anything about EventLive: pricing, planning your livestream, or watching an event.": "こんにちは！料金、ライブ配信の準備、イベントの視聴方法など、EventLiveについて何でもお尋ねください。",
  "Have an account? Sign in for help with your events": "アカウントをお持ちですか？ログインすると、イベントについてのサポートを受けられます",
  "Ask anything about broadcasting, your events or pricing. I can use your account details and the screen you’re on to help.": "配信、イベント、料金について何でもお尋ねください。アカウント情報や表示中の画面をもとにお手伝いできます。",
  "Retry message": "メッセージを再送信",
  "Remove photo": "写真を削除",
  "Support message": "サポートへのメッセージ",
  "Tell us what you’re trying to do…": "やりたいことを教えてください…",
  "Attach": "添付",
  "Could not open your photos.": "写真を開けませんでした。",
  "Send": "送信",
  "Close support backdrop": "サポートを閉じる（背景）",
  "AI assistant is typing": "AIアシスタントが入力中",
  "AI assistant": "AIアシスタント",
  "Please sign in to contact support.": "サポートに問い合わせるにはログインしてください。",
  "Could not reach support. Check your internet connection and try again.": "サポートに接続できませんでした。インターネット接続を確認して、もう一度お試しください。",
  "Support is temporarily unavailable. Please try again.": "サポートは一時的にご利用いただけません。もう一度お試しください。",
  "Could not send your message.": "メッセージを送信できませんでした。",
  "No message sent": "メッセージは送信されていません",
  "Demo delivery: screenshot included · {platform}": "デモ送信：スクリーンショットあり · {platform}",
  "Demo delivery: no screenshot · {platform}": "デモ送信：スクリーンショットなし · {platform}",
  "EventLive · Widget test": "EventLive · ウィジェットのテスト",
  "Synthetic account and replies. No customer data or live API calls.": "架空のアカウントと返信です。顧客データや実際のAPI呼び出しは使用しません。",
  "Your events": "あなたのイベント",
  "Family celebration": "家族のお祝い",
  "Published · Recording ready": "公開済み · 録画の準備完了",
  "Demo delivery status": "デモ送信のステータス",
  "{brand} support team": "{brand}サポートチーム",
  "You’re chatting with the {brand} support team": "{brand}サポートチームとチャット中です",
  "You’re talking with the {brand} AI assistant": "{brand}のAIアシスタントと会話中です",
  "The {brand} team is answering here. If you step away, they’ll also reply by email.": "{brand}のチームがこちらで回答します。席を外した場合は、メールでも返信が届きます。",
  "Hi! Ask me anything about YouthStream: plans and pricing, streaming your team’s games, or watching a game.": "こんにちは！プランと料金、チームの試合の配信、試合の視聴方法など、YouthStreamについて何でもお尋ねください。",
  "Using the app? For help with your account, open Support Chat in YouthStream’s Profile.": "アプリをお使いですか？アカウントについてのサポートは、YouthStreamの「プロフィール」から「サポートチャット」を開いてください。"
}
